<template>
    <div class="topBarMobile">
        <!-- 1) left -->
        <div class="lc_left" >

            <!-- back arrow -->
            <img class="TQ_verticalAlignMiddle lc_backBtn"
                 v-if="p_showBackBtn_b"
                 @click="m_moveBack_f"
                 :class="{'TQ_width_28px' :com_mobileScreenSize_b, 'TQ_width_36px' : !com_mobileScreenSize_b}"
                 :src="ass_img_arrowHeadLeft_p"/>

            <!-- logo -->
            <logo :width="com_mobileScreenSize_b ? '54px' : '68px'"
                  v-else-if="!com_pathOngoingQuest_b"
                  class="TQ_margin_2px TQ_verticalAlignMiddle"
                  v-tqdblclick="route_refreshPage"/>

            <!-- clock -->
            <div class="TQ_inline TQ_border_p TQ_textColor_purple TQ_borderRadius TQ_verticalAlignMiddle lc_clock TQ_padding_2px"
                 v-if="com_pathOngoingQuest_b"
                 :class="{'TQ_text_20px' :com_mobileScreenSize_b, 'TQ_text_28px' : !com_mobileScreenSize_b}">
                {{format_duration_hhmmss(p_millSecToEndQuest_n)}}
            </div>

            <!-- current points -->
            <div class="TQ_inline TQ_textColor_white TQ_borderRadius TQ_verticalAlignMiddle lc_clock TQ_bg_purple TQ_padding_2px"
                 v-if="com_pathOngoingQuest_b && p_currentScore_n != null"
                 :class="{'TQ_text_20px' :com_mobileScreenSize_b, 'TQ_text_28px' : !com_mobileScreenSize_b}">
                <div class="TQ_inline TQ_verticalAlignMiddle"> {{p_currentScore_n}} </div>
                <div class="TQ_padding_1px TQ_inline TQ_verticalAlignMiddle"> </div>
                <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_borderRadius TQ_verticalAlignMiddle"
                          :class="{'TQ_width_16px' :com_mobileScreenSize_b, 'TQ_width_24px' : !com_mobileScreenSize_b}"/>
            </div>

            <!-- wifi -->
            <img :src="ass_img_noWifi"
                 v-if="!p_networkActive_b"
                 class="TQ_verticalAlignMiddle"
                 :class="{'lc_noWifiIcon_small TQ_width_28px' :com_mobileScreenSize_b, 'lc_noWifiIcon_big TQ_width_36px ' : !com_mobileScreenSize_b, 'lc_clock' : com_pathOngoingQuest_b}"/>
        </div>

        <!-- 2) center -->
        <div class="TQ_center" >

            <!-- nothing -->
            <div v-if="(!com_mobileScreenSize_b && com_pathOngoingQuest_b) || (p_showBackBtn_b && !com_pathOngoingQuest_b)"> 

                <!-- whiteLabel -->
                <img v-if="com_showWhiteLabel_b" 
                    class="TQ_margin_2px TQ_verticalAlignMiddle TQ_height_44px"
                    :src="p_whiteLabel_c.wl_logoUrl_s" 
                    v-tqdblclick="route_refreshPage"
                />

                <!-- TQ logo -->
                <logo v-else
                    :width="com_mobileScreenSize_b ? '54px' : '68px'"
                    class="TQ_margin_2px TQ_verticalAlignMiddle"
                    v-tqdblclick="route_refreshPage"/>

            </div>

            <!-- right -->
            <div class="lc_right" >

                <!-- ongoing quest -->
                <div v-if="com_pathOngoingQuest_b" class="TQ_inline">

                    <!-- clues -->
                    <tq-notification-container :num="p_cluesNum_n" :show="p_cluesNum_n > -1" p_top="-8px" v-if="p_cluesNum_n > -1"

                                            :class="{'lc_cluesIcon_small' :com_mobileScreenSize_b, 'lc_cluesIcon_big' : !com_mobileScreenSize_b}">
                        <img :src="ass_img_idea_p" :class="{'TQ_width_28px'  :com_mobileScreenSize_b, 'TQ_width_32px' : !com_mobileScreenSize_b}"/>
                    </tq-notification-container>

                    <!-- skips -->
                    <tq-notification-container :num="p_skipsNum_n" :show="p_skipsNum_n > -1" p_top="-8px" v-if="p_skipsNum_n > -1"
                                            :class="{'lc_skipIcon_small'  :com_mobileScreenSize_b, 'lc_skipIcon_big' : !com_mobileScreenSize_b}">
                        <img :src="ass_img_skip_p"  :class="{'TQ_width_28px' :com_mobileScreenSize_b, 'TQ_width_32px' : !com_mobileScreenSize_b}"/>
                    </tq-notification-container>

                    <div class="TQ_padding_4px TQ_inline"></div>

                </div>

                <menu-drop-down
                    class="TQ_align_initial"
                    :iconWidth="com_mobileScreenSize_b  ? '32px' : '40px'"
                    :iconMargin="com_mobileScreenSize_b ? '4px'  : '5px' "

                    :p_nav-bar_menu_ac="p_navBar_menu_ac"
                    :p_current-user-data_c="p_currentUserData_c"
                    :p_system-lang-code_e="p_systemLangCode_e"
                    :p_current-currency_e="p_currentCurrency_e"
                    :p_run-in_e="p_runIn_e"
                    :pe_change-currency_f="pe_changeCurrency_f"
                />

            </div>

        </div>

    </div>
</template>

<script>
    import Logo from "../../components/a_smartIcons/si_Logo";
    import {FB_UserData, FB_WhiteLabel} from "../../../functions/src/shareCode/Share_S_Classes";
    import {
        enum_moveToLocationOptions, enum_moveToOptions, enum_screenSizesOptions_n, enum_runIn_es
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        route_back,
        route_currentPath_s,
        route_moveToRoute,
        route_refreshPage
    } from "../../router";
    import TqPopup from "../../components/basic/TqPopup";
    import TqDropdown from "../../components/basic/TqDropdown";
    import MenuDropDown from "./C_App_MenuDropDown";
    import {
        ass_img_arrow_head_left_p, ass_img_idea_p,
        ass_img_noWifi, ass_img_oneStar_w,
        ass_img_shareLocation, ass_img_skip_p, ass_img_threeStars, ass_img_unlock2_w
    } from "../../assets/scripts/Ass_Files";
    import {enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqNotificationContainer from "../../components/basic/TqNotificationContainer";
    import {format_duration_hhmmss} from "../../../functions/src/shareCode/Share_S_Format";
    import TqImage from "../../components/basic/TqImage";
    import TqLink from "@/components/basic/TqLink";
    export default {
        name: "topBarMobile",
        components: {TqLink, TqImage, TqNotificationContainer, MenuDropDown, TqDropdown, TqPopup, Logo},
        props:{
            p_navBar_menu_ac : {
                type: Array,
                require: true,
            },

            p_showBackBtn_b:{
                require:true,
                type: Boolean
            },
            p_backTo_s:{
                require:true,
                type: String
            },
            p_currentUserData_c:{
                type: FB_UserData,
                require: true
            },
            p_systemLangCode_e:{
                type:String,
                require: true
            },
            p_networkActive_b:{
                type:Boolean,
                require: true
            },

            p_windowSize_e:{
                type: Number,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_screenSizesOptions_n, val)
                }
            },
            p_skipsNum_n:{
                type: Number,
                require : true,
            },
            p_cluesNum_n:{
                type: Number,
                require : true,
            },
            p_currentScore_n:{
                type: Number,
                require : true,
            },
            p_millSecToEndQuest_n:{
                type: Number,
                require : true,
            },
            p_whiteLabel_c:{
                type: FB_WhiteLabel,
            },
            p_runIn_e: {
                type: String,
                require: true,
                validator(val_e) {
                    return validator_enum_fb(enum_runIn_es, val_e)
                }
            },
            p_currentCurrency_e:{},
            pe_changeLangCode_f:{},
            pe_changeCurrency_f:{},

        },
        data(){
            return {
                ass_strings                    : ass_strings,
                enum_langCodes_i                : enum_langCodes,
                enum_moveToLocationOptions_i    : enum_moveToLocationOptions,
                enum_moveToOptions    : enum_moveToOptions,
                route_refreshPage               : route_refreshPage,
                format_duration_hhmmss : format_duration_hhmmss,

                ass_img_noWifi          : ass_img_noWifi,
                ass_img_shareLocation   : ass_img_shareLocation,
                ass_img_arrowHeadLeft_p : ass_img_arrow_head_left_p,
                ass_img_idea_p          : ass_img_idea_p,
                ass_img_skip_p          : ass_img_skip_p,
                ass_img_unlock2_w       : ass_img_unlock2_w,
                ass_img_threeStars       : ass_img_threeStars,
                ass_img_oneStar_w       : ass_img_oneStar_w,

            }
        },
        computed : {
            com_mobileScreenSize_b(){
                return this.p_windowSize_e === enum_screenSizesOptions_n.mobile
            },
            com_pathOngoingQuest_b(){
                return route_currentPath_s(this.$route).includes(enum_moveToOptions.ongoing)
            },
            com_showWhiteLabel_b(){
                return this.com_pathOngoingQuest_b && this.p_whiteLabel_c.wl_logoUrl_s
            }
        },
        methods:{

            m_moveBack_f(){

                if(this.p_backTo_s){
                    route_moveToRoute(this.p_backTo_s)
                }else{
                    route_back()
                }
            }
        }


    }
</script>

<style scoped lang="scss">
    .topBarMobile{
        width: 100%;
        background: white;
        padding: 0;
        height: 40px;

        &.tablet{
            height: 50px;
        }


        .lc_left{
            position: fixed;
            top: 0px;
            left: 0px;
            cursor: pointer;
            height: inherit;


            .lc_backBtn {
                margin-top: 6px;
            }
            .lc_clock{
                margin-top: 5px;
                margin-left: 6px;
            }
        }


        .lc_right{

            position: fixed;
            top: 0px;
            right: 0px;

            .lc_cluesIcon_small,
            .lc_skipIcon_small{
                position: absolute;
                top: 8px;

            }

            .lc_skipIcon_big,
            .lc_cluesIcon_big{
                position: absolute;
                top: 10px;
            }

            .lc_skipIcon_small{
                right: 90px;

            }
            .lc_cluesIcon_small{
                right: 54px;
            }

            .lc_skipIcon_big{
                right: 104px;

            }
            .lc_cluesIcon_big{
                right: 64px;
            }



        }






    }

</style>
